import { render, staticRenderFns } from "./SendMessageReplyInputBox.vue?vue&type=template&id=6666bb71&scoped=true&lang=pug"
import script from "./SendMessageReplyInputBox.vue?vue&type=script&lang=ts"
export * from "./SendMessageReplyInputBox.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageReplyInputBox.vue?vue&type=style&index=0&id=6666bb71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6666bb71",
  null
  
)

export default component.exports